/**
 * Pre-compiled es messages for LocalizedField
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  hideCurrencies: `Ocultar todas las monedas`,
  hideLanguages: `Ocultar todas las monedas`,
  infoBoxTriggerAriaLabel: `más información`,
  missingRequiredField: `Este valor es necesario. Proporciona al menos un valor.`,
  showCurrencies: `Mostrar todas las monedas`,
  showLanguages: `Mostrar todos los idiomas`,
};
